
function handleImg (el, binding, vnode) {
  if (!binding.value) {
    return
  }
  if (binding.modifiers.src) {
    el.src = vnode.context.$hb_tools.encodeHbImgUri(binding.value, 'image')
  }
}

export default {
  install (Vue) {
    Vue.directive('hb-img', {
      bind: handleImg,
      update: handleImg
    })
  }
}